<template lang="html">
  <b-form role="form" @submit.prevent="onSubmit($event.target)"  class="col-lg-9 col-page-content page-style-2">
    <div class="row">

      <div class="col-12">
        <div class="box-bubble">
          <div class="row">

            <div class="col-12 box-acc-title-s1">
              <h4>Mi Perfil</h4>
              <hr />
            </div>

            <b-form-group class="col-md-12 custom-f-group-1" label="Nombre completo*" label-for="i-1">
              <b-form-input
                id="i-1"
                v-model="form.nombre"
                type="text"
                placeholder="Stefany"
                required
              ></b-form-input>
            </b-form-group>

           <!--  <b-form-group class="col-md-6 custom-f-group-1" label="Apellidos*" label-for="i-2">
              <b-form-input
                id="i-2"
                v-model="form.apellidos"
                type="text"
                placeholder="Bosch Cinco"
                required
              ></b-form-input>
            </b-form-group> -->

            <b-form-group class="col-md-6 custom-f-group-1" label="Correo Electrónico*" label-for="i-3">
              <b-form-input
                id="i-3"
                v-model="form.email"
                type="email"
                placeholder="contacto@correo.com"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="col-md-6 custom-f-group-1" label="Fecha de Nacimiento*" label-for="i-4">
              <b-form-input
                id="i-4"
                v-model="form.fecha_nacimiento"
                type="date"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="col-md-6 custom-f-group-1" label="Teléfono*" label-for="i-5">
              <b-form-input
                id="i-5"
                v-model="form.telefono"
                type="number"
                placeholder="3311112222"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="col-md-6 custom-f-group-1" label="Sector*" label-for="i-6">
              <b-form-select id="i-6" required v-model="form.categorias_id">
                <b-form-select-option :value="null" disabled>Seleccione una opción</b-form-select-option>
                <b-form-select-option v-for="(category,indx) in areasOpcs" :key="indx" :value="category.id">{{category.nombre}}</b-form-select-option>
                
              </b-form-select>
            </b-form-group>

            <b-form-group class="col-md-6 custom-f-group-1" label="Título del Perfil*" label-for="i-7">
              <b-form-input
                id="i-7"
                v-model="form.nombre_responsable"
                type="text"
                placeholder="Contadora"
                required
              ></b-form-input>
            </b-form-group>

            <div class="col-md-6">
              <b-form-group class="col-12 custom-f-group-1 px-0 mb-0" label="Sueldo deseado*">
              </b-form-group>

              <div class="row">
                <b-form-group class="col-md-6 custom-f-group-1">
                  <b-form-select required v-model="form.sueldodeseado_periodo">
                    <b-form-select-option :value="null" disabled>Seleccione una opción</b-form-select-option>
                    <b-form-select-option value="diario">Diario</b-form-select-option>
                    <b-form-select-option value="semanal">Semanal</b-form-select-option>
                    <b-form-select-option value="quincenal">Quincenal</b-form-select-option>
                    <b-form-select-option value="mensual">Mensual</b-form-select-option>
                    <b-form-select-option value="anual">Anual</b-form-select-option>
                    <b-form-select-option value="por_proyeto">Por proyeto</b-form-select-option>
                  </b-form-select>
                </b-form-group>

                <b-form-group class="col-md-6 custom-f-group-1">
                  <currency-input class="form-control" placeholder="$0.00" v-model="form.sueldodeseado" />
                </b-form-group>
              </div>
            </div>

            <b-form-group class="col-lg-12 custom-f-group-1" label="Descripción*">
              <editor
                  v-model="form.descripcion"
                 api-key="voyk5grgw5zv5ueomjptgwscn9vyw7a0sifs0oy5fxj4befk"
                 :init="{
                   height: 265,
                   menubar: false,
                   language: 'es_MX',
                   paste_block_drop: false,
                   paste_as_text: !0,
                   entity_encoding: 'raw',
                   plugins: [
                     'advlist autolink lists link image charmap print preview anchor',
                     'searchreplace visualblocks code fullscreen',
                     'insertdatetime media table paste code help wordcount'
                   ],
                   toolbar:
                     'undo redo | formatselect | bold italic backcolor | \
                     alignleft aligncenter alignright alignjustify | \
                     bullist numlist outdent indent | removeformat'
                 }"
              />
            </b-form-group>

          </div>
        </div>

        <div class="mt-4 box-bubble">
          <div class="row">

            <div class="col-12 box-acc-title-s1">
              <h4>Dirección</h4>
              <hr />
            </div>

            <b-form-group class="col-md-6 custom-f-group-1" label="País*" label-for="i-9">
              <b-form-select id="i-9" required v-model="form.pais_id">
                <b-form-select-option :value="null" disabled>Seleccione una opción</b-form-select-option>
                <b-form-select-option value="mx">México</b-form-select-option>
                <b-form-select-option value="usa">USA</b-form-select-option>
              </b-form-select>
            </b-form-group>

            <b-form-group class="col-md-6 custom-f-group-1" label="Estado*" label-for="i-10">
              <b-form-select id="i-10" required v-model="form.estado_id">
                <b-form-select-option :value="null" disabled>Seleccione una opción</b-form-select-option>
                <b-form-select-option :value="state.id" v-for="state in statesOpcs" :key="state.id">{{state.name}}</b-form-select-option>
              </b-form-select>
            </b-form-group>

            <b-form-group class="col-md-6 custom-f-group-1" label="Ciudad*" label-for="i-11">
              <b-form-select id="i-11" required v-model="form.ciudad_id">
                <b-form-select-option :value="null" disabled>Seleccione una opción</b-form-select-option>
                <b-form-select-option :value="town.id" v-for="town in townsOpcs" :key="town.id">{{town.name}}</b-form-select-option>
              </b-form-select>
            </b-form-group>

            <b-form-group class="col-md-6 custom-f-group-1" label="Código Postal*" label-for="i-12">
              <b-form-input
                id="i-12"
                v-model="form.cp"
                type="number"
                placeholder="Código Postal"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="col-lg-12 custom-f-group-1" label="Dirección completa*" label-for="i-13">
              <b-form-input
                id="i-13"
                v-model="form.domicilio"
                type="text"
                placeholder="Calle, número, colonia"
                required
              ></b-form-input>
            </b-form-group>
          </div>
        </div>

        <div class="mt-4 box-bubble">
          <div class="row">

            <div class="col-12 box-acc-title-s1">
              <h4>Redes sociales</h4>
              <hr />
            </div>

            <b-form-group class="col-md-4 custom-f-group-1" label="Facebook*" label-for="i-14">
              <b-form-input
                id="i-14"
                v-model="form.facebook"
                type="text"
                placeholder="#"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="col-md-4 px-md-1 custom-f-group-1" label="Twitter*" label-for="i-15">
              <b-form-input
                id="i-15"
                v-model="form.twitter"
                type="text"
                placeholder="#"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="col-md-4 custom-f-group-1" label="LinkedIn*" label-for="i-16">
              <b-form-input
                id="i-16"
                v-model="form.linkedin"
                type="text"
                placeholder="#"
                required
              ></b-form-input>
            </b-form-group>
          </div>
        </div>

        <div class="mt-2 px-0 box-empty-bubble">
          <b-form-checkbox
            class="mb-3 custom-checkbox-s1"
            v-model="form.check"
            name="checkbox-1"
            value="accepted"
            unchecked-value="not_accepted"
            required>
            Al hacer clic en la casilla de verificación, acepta nuestros <router-link to="">Términos y condiciones</router-link> y <router-link to="">Política de privacidad</router-link>
          </b-form-checkbox>

          <b-button type="submit" class="btn-HelvNeu btn-squ-cur-1 btn-send">Guardar perfil</b-button>
        </div>
      </div>

    </div>
    <sweet-modal ref="modalLoading" hide-close-button blocking>

        <img src="/public/images/shared/loading.gif" width="30%">
        <p style="text-align: center;"><b>Cargando...</b></p>
    </sweet-modal>
    <sweet-modal ref="modalAlert" :icon="modal.icon">
          <p>{{modal.msg}}</p>
           <br><br>
          <a class="btn btn-info" @click="$refs.modalAlert.close()">Aceptar</a>
    </sweet-modal>
  </b-form>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';
export default {
  data(){
    return{
      form: {
        name: null,
        sector: null,
        pais: null,
        estado: null,
        ciudad: null,
      },
      modal:{
          icon:null,
          msg:null
      },
      statesOpcs:[],
      townsOpcs:[],
      areasOpcs:[],
    }
  },
  watch:{
      'form.estado_id':function(val){
          this.getTownsOpcs(val);
      },      
  },
  methods: {
    onSubmit(form) {
          
          var hoy = new Date();
          var cumpleanos = new Date(this.form.fecha_nacimiento);
          var edad = hoy.getFullYear() - cumpleanos.getFullYear();
          var m = hoy.getMonth() - cumpleanos.getMonth();

          if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
              edad--;
          }

          if (edad < 18) {
              this.modal.icon = 'error';
              this.modal.msg = 'Tu edad debe de ser mayor a 18 años';
              this.$refs.modalAlert.open();
              return;
          }

          //event.preventDefault();
          this.$refs.modalLoading.open();
          //event.preventDefault();
          var data=tools.params(form,this.form);
      
          axios.post(tools.url("/api/admin/company/updateProfileFront"),data).then((response)=>{
              this.$root.auth();
              this.$refs.modalLoading.close();
              this.modal.icon = 'success';
              this.modal.msg = 'Información actualizada correctamente';
              this.$refs.modalAlert.open();

              
          }).catch((error)=>{
              this.$refs.modalLoading.close();
              this.modal.icon = 'error';
              this.modal.msg = 'Ocurrio un error al guardar la información';
              this.$refs.modalAlert.open();

          });
      },
      getStatesOpcs(){
        axios.get(tools.url("/states")).then((response)=>{
            this.statesOpcs = response.data;
          }).catch((error)=>{
          });
      },
      getTownsOpcs(state_id){
        axios.get(tools.url("/cities/"+state_id)).then((response)=>{
            this.townsOpcs = response.data;
          }).catch((error)=>{
          });
      },
      getCategories(){
          axios.get(tools.url("/categoriesFront"))
          .then((response)=>{
              this.areasOpcs = response.data;
          }).catch((error)=>{
            
          });
      },

  },
  mounted(){
      this.getCategories();
      this.getStatesOpcs();
      
      this.form = this.$root.user.usercompany;
      
      this.form.check = 'not_accepted';
  },

  components: {
    'editor': Editor
  },
}
</script>
